import { useAppDispatch, useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import {
	getSummaryForCurrentTerm,
	getPaymentDate,
	getBillingSchedule,
} from '@acorn-portal/shared/src/store/managedPayments.slice';
import API_POLICY_TOKEN from '@acorn-portal/shared/src/services/managedPaymentsInstance';
import { useEffect } from 'react';

const useManagedPaymentsDetails = (policyToken: string) => {
	const dispatch = useAppDispatch();
	const managedPaymentsDetails = useAppSelector((redux) => redux.managedPayments);

	useEffect(() => {
		if (!policyToken) return;
		API_POLICY_TOKEN.defaults.headers.common['X-Token'] = policyToken;
		const fetchMangedPaymentsDetails = async () => {
			await Promise.all([
				dispatch(getSummaryForCurrentTerm()),
				dispatch(getPaymentDate()),
				dispatch(getBillingSchedule()),
			]);
		};

		fetchMangedPaymentsDetails();
	}, [dispatch, policyToken]);

	return { managedPaymentsDetails };
};

export default useManagedPaymentsDetails;
